import React, { useContext } from "react";
import classNames from "classnames";
import GroupContext from "../../context/group";

const FormText = ({ id, field, label, className, placeholder, isRequired = false, ...other }) => {
  const { formData, onChange, formErrors } = useContext(GroupContext);
  return (
    <label
      className={classNames("form__textarea-label", { "mb-4": !!formErrors[field] })}
      htmlFor={id}
    >
      {label}
      <textarea
        className={`form__textarea${className ? ` ${className}` : ""}`}
        type="text"
        id={id}
        name={field}
        aria-label={label || placeholder}
        data-required={isRequired}
        value={formData[field]}
        onChange={onChange}
        placeholder={placeholder}
        {...other}
      />
      {formErrors[field] && (
        <span className="form__error-message d-inline">{formErrors[field]}</span>
      )}
    </label>
  );
};

export default FormText;
